export const PANEL_CLASSES = "bg-white rounded-lg border border-divider-lines overflow-hidden flex flex-col";

export const HEADER_CLASSES = "px-3.5 py-2.5 font-semibold text-sm text-off-black border-b border-divider-lines bg-very-light-gray flex justify-between items-center";

export const SECTION_LABEL = "text-[12px] font-bold text-medium-gray uppercase tracking-wide mb-2";

const MAPPING_DISPLAY_BASE = "rounded-md px-2.5 py-1 font-mono text-xs flex items-center gap-1.5 flex-1 min-h-[28px] border";

// Valid mapping (path found in schema): subtle — dark-gray border + black text, no fill — to reduce color noise.
export const MAPPING_DISPLAY = `${MAPPING_DISPLAY_BASE} border-secondary-gray text-off-black`;

// Invalid mapping (path not in schema): kept prominent with a yellow fill so it stands out as a warning.
export const MAPPING_DISPLAY_WARNING = `${MAPPING_DISPLAY_BASE} bg-warning-yellow border-warning-yellow text-warning-dark-yellow`;

export const DROP_ZONE = "flex-1 border-2 border-dashed rounded-md px-3 py-1.5 min-h-[28px] text-xs text-center transition-all";

export const DROP_ZONE_ACTIVE = "border-dark-green bg-light-green text-dark-green";

export const DROP_ZONE_IDLE = "border-field-outline text-medium-gray";

export const LOCKED_FIELD = "bg-very-light-gray rounded-md px-2.5 py-1 font-mono text-xs text-medium-gray flex items-center gap-1.5 flex-1 min-h-[28px] border border-field-outline";
